// 中央配置ボタン
import React from 'react';
import { Button } from 'react-bootstrap';

interface Props {
  label: string;
  disabled?: boolean;
  handleClick?: React.MouseEventHandler<HTMLButtonElement>;
}

const CenterButton: React.FC<Props> = ({ label, disabled, handleClick }) => {
  if (handleClick === undefined) {
    // エラー防止:ハンドラの指定がない場合は空のハンドラを設定する
    handleClick = () => {};
  }

  return (
    <div className="center-button">
      <Button
        // ボタンのクリック設定
        onClick={handleClick}
        className="col-xs-6 col-sm-4 col-md-2 col-4"
        size="lg"
        variant="custom"
        disabled={disabled}
      >
        {label}
      </Button>
    </div>
  );
};

export default CenterButton;
